import services from '../../../services'

const state = {
}

const actions = {
  async organizationTree ({commit}) {
    return await services.organization_loadTree()
  },
  async getOrganizationById ({commit}, id) {
    let params = {
      id: id
    }
    return (await services.organization_byId({params: params}))
  },
  async addOrganizationTree ({commit}, options) {
    return await services.organization_addTree(options)
  },
  async deleteOrganizationTree ({commit}, id) {
    let params = {
      id: id
    }
    return await services.organization_delete({params: params})
  },
  async updateOrganizationTree ({commit}, options) {
    return await services.organization_update(options.id, options)
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/organization.js